import React, { useState, useEffect } from 'react';
import { Database, Filter, MessageSquare, Check } from 'lucide-react';

const steps = [
  { text: "J'identifie la ou les bases en lien avec votre réponse", icon: Database, duration: 3000 },
  { text: "J'extrais les informations les plus pertinentes", icon: Filter, duration: 3000 },
  { text: "Je prépare votre réponse", icon: MessageSquare, duration: null },
];

const LoadingSequence = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const timers = [];
    let elapsed = 0;
    for (let i = 0; i < steps.length - 1; i++) {
      elapsed += steps[i].duration;
      timers.push(setTimeout(() => setCurrentStep(i + 1), elapsed));
    }
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="space-y-2.5">
      {steps.map((step, i) => {
        const isActive = i === currentStep;
        const isDone = i < currentStep;
        const isPending = i > currentStep;
        const Icon = step.icon;

        if (isPending) return null;

        return (
          <div
            key={i}
            className="flex items-center space-x-3 animate-in fade-in slide-in-from-bottom-2 duration-400"
            style={{ animationDelay: `${i * 50}ms` }}
          >
            {isDone ? (
              <div className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                <Check className="w-3 h-3 text-emerald-600" />
              </div>
            ) : (
              <div className="w-5 h-5 flex-shrink-0 relative">
                <div className="absolute inset-0 rounded-full bg-cyan-500 animate-ping opacity-30" />
                <div className="w-5 h-5 rounded-full bg-cyan-100 flex items-center justify-center">
                  <Icon className="w-3 h-3 text-cyan-600" />
                </div>
              </div>
            )}
            <span
              className={`text-sm ${
                isDone ? 'text-emerald-600 line-through opacity-60' : 'text-slate-700 font-medium'
              }`}
            >
              {step.text}
              {isActive && (
                <span className="inline-flex ml-1.5">
                  <span className="w-1 h-1 bg-cyan-500 rounded-full animate-bounce inline-block" />
                  <span className="w-1 h-1 bg-cyan-500 rounded-full animate-bounce inline-block ml-0.5" style={{ animationDelay: '0.15s' }} />
                  <span className="w-1 h-1 bg-cyan-500 rounded-full animate-bounce inline-block ml-0.5" style={{ animationDelay: '0.3s' }} />
                </span>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default LoadingSequence;
